<template>
  <div id="contact" class="bg-black border-t-8 border-gold flex flex-col items-center py-20">
    <p class="w-full md:w-2/3 bg-gray bg-opacity-50 border-y-8 border-gold-center text-2xl py-6 px-6 text-balance text-off-white">
      With a commitment to excellence, we specialize in providing top-tier security services for government agencies, institutions, and organizations across the nation.
    </p>
    <p class="hidden md:block text-2xl text-gold hover:text-off-white mt-20 "><a href="mailto:iseeyouinc4@iseeyousecurity.ca">iseeyouinc4@iseeyousecurity.ca</a></p>
  </div>
</template>
<script setup>
</script>